/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  localizedNewsItemContents: {
    description: 'Localized news item contents',
    validators: [validator('has-many')],
  },
  newsfeedIds: {
    description: 'Newsfeed assignments',
    validators: [
      validator('length', {
        min: 1,
        message: 'Assign News Item to at least 1 newsfeed before setting it live',
      }),
    ],
  },
});
